import { httpGet, httpPut, httpDelete, httpPost } from "../../../Util/http";
import { addAlert } from "../../../MsgNotify/msgNotifyActions";
import { isUsageValid, attemptSaveUsage } from "./Usage/actions";
import { isActivitiesValid, attemptSaveActivities } from "./Activities/actions";
import { isEmployeesValid, attemptSaveEmployees } from "./Employees/actions";
import {
  isDeliveryNotesValid,
  attemptSaveDeliveryNotes,
} from "./DeliveryNotes/actions";
import { attemptSaveDescription } from "./Description/actions";
import { attemptSaveRemark } from "./Remark/actions";
import { attemptSaveMeasurements } from "./Measurements/actions";
import { routeActions } from "redux-simple-router";
import { attemptSaveControlAreas } from "./ControlArea/actions";

export const DAILY_REPORT_GET_REQUEST = "DAILY_REPORT_GET_REQUEST";
export const dailyReportGetRequest = () => {
  return {
    type: DAILY_REPORT_GET_REQUEST,
  };
};

export const DAILY_REPORT_GET_SUCCESS = "DAILY_REPORT_GET_SUCCESS";
export function dailyReportGetSuccess(json, recentlyDeletedDailyReportId) {
  let employees = [];
  //map the employees to correct format
  json.employees.forEach((employee) => {
    let newEmployee = { ...employee };
    if (employee.absence) {
      newEmployee.absence.date = new Date(employee.absence.date);
    }
    if (employee.timeRegistrations.length === 0) {
      newEmployee.timeRegistrations.push({
        employeeFunction: "0",
        hours: 0,
        nightHours: 0,
        checkIn: null,
        checkOut: null,
      });
    }
    employees.push(newEmployee);
  });

  let signature = json.signature
    ? {
      ...json.signature,
      dateOfSignature: new Date(json.signature.dateOfSignature),
    }
    : null;

  //the dailyReport chooser
  let listOfDailyReports = json.versions ? json.versions : [];
  let currentDailyReportId = json.aggregateId;

  //check if its a new dailyReport
  let isNewDailyReport = true;
  listOfDailyReports.forEach((dailyReport) => {
    if (dailyReport.no === currentDailyReportId) isNewDailyReport = false;
    if (
      recentlyDeletedDailyReportId &&
      recentlyDeletedDailyReportId === dailyReport.no
    ) {
      dailyReport.deleted = true;
    }
  });
  if (isNewDailyReport) {
    listOfDailyReports.push({ no: currentDailyReportId, deleted: false });
  }

  //description logic
  let description = json.description ? json.description : "";
  let splittetDescription = description.split("&:TRANSLATED:&");
  description = splittetDescription[0];
  let englishDescription =
    splittetDescription.length > 1 ? splittetDescription[1] : null;

  //remark logic
  let remark = json.remark ? json.remark : "";
  let splittetRemark = remark.split("&:TRANSLATED:&");
  remark = splittetRemark[0];
  let englishRemark = splittetRemark.length > 1 ? splittetRemark[1] : null;

  //all data
  let activities = json.activities;
  let materiel = json.materiel;
  let materiale = json.materiale;
  let deliveryNotes = json.deliveryNotes;
  let measurements = json.measurements;
  let predefinedActivities = json.predefinedActivities;
  let controlAreas = json.controlAreas;
  // checkin check out mode
  let checkInCheckOutMode = json.checkInCheckOutMode;

  //add an empty to the activities
  activities.push({ name: "", hours: 0, activity: "Diverse" });
  materiel.push({ id: null, name: "", unit: null, amount: 0, subs: [] });
  materiale.push({ id: null, name: "", unit: null, amount: 0, subs: [] });
  deliveryNotes.push({ number: "", supplier: "", specification: null });
  measurements.push({ type: "", length: 0, depth: 0, area: "", amount: 0 });
  controlAreas.push({
    type: "",
    area: "",
    temp: 0,
    crack: 0,
    control: 0,
    rf: 0,
    mpa: 0,
  });
  return {
    type: DAILY_REPORT_GET_SUCCESS,
    employees,
    activities,
    materiel,
    materiale,
    description: description,
    englishDescription: englishDescription,
    deliveryNotes,
    measurements,
    isEdit: json.isEdit,
    signature,
    approved: json.approved,
    stamdata: {
      client: json.client,
      project: json.project,
      workplaceName: json.workplaceName,
    },
    remark: remark,
    englishRemark,
    currentDailyReportId,
    listOfDailyReports,
    registeredEmployees: [],
    checkInCheckOutMode,
    predefinedActivities,
    pics: json.images ? json.images : [],
    controlAreas: controlAreas,
  };
}

export const DAILY_REPORT_GET_FAILURE = "DAILY_REPORT_GET_FAILURE";
export function dailyReportGetFailure() {
  return {
    type: DAILY_REPORT_GET_FAILURE,
  };
}

export function attemptGetDailyReport(currentDailyReportId) {
  return (dispatch, getState) => {
    var _url = process.env.REACT_APP_webApiEndPoint + "api/dailyreport";
    dispatch(dailyReportGetRequest());
    return httpPost(_url, currentDailyReportId)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch(dailyReportGetSuccess(json));
      })
      .catch((e) => {
        dispatch(dailyReportGetFailure());
        dispatch(addAlert("Kunne ikke hente dagrapport"));
        let route = window.location.pathname;
        if (getState().routing.location) {
          route = getState().routing.location.pathname;
        }
        const path = route.replace("dagrapport", "oversigt");
        dispatch(routeActions.push(path));
        console.log(e);
      });
  };
}

export function attemptGetDailyReportInit(
  fetchDate,
  workplaceId,
  recentlyDeletedDailyReport
) {
  return (dispatch, getState) => {
    //if link is set in reducer, then fetch the dailyReport directly
    let dailyReportIdLink = getState().dailyReportReducer.dailyReportIdLink;
    if (dailyReportIdLink != null) {
      dispatch(attemptGetDailyReport(dailyReportIdLink));
      return;
    }
    let date = fetchDate ? fetchDate : getState().dailyReportReducer.date;
    date = JSON.parse(JSON.stringify(date));
    let _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/dailyreport/init/" +
      workplaceId +
      "?date=" +
      date;

    //if employeeId is set in the reducer, add it to the url
    let dailyReportEmployeeId = getState().dailyReportReducer
      .dailyReportEmployeeId;
    if (dailyReportEmployeeId) {
      _url += "&employeeId=" + dailyReportEmployeeId;
    }
    dispatch(dailyReportGetRequest());
    return httpGet(_url)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch(dailyReportGetSuccess(json, recentlyDeletedDailyReport));
      })
      .catch((e) => {
        dispatch(dailyReportGetFailure());
        dispatch(addAlert("Kunne ikke hente dagrapport"));
        const state = getState();
        if (
          state &&
          state.routing &&
          state.routing.location &&
          state.routing.location.pathname
        ) {
          let route = state.routing.location.pathname.replace(
            "dagrapport",
            "oversigt"
          );
          dispatch(routeActions.push(route));
        }
        console.log(e);
      });
  };
}

export function attemptCreateDailyReport(workplaceId) {
  return (dispatch, getState) => {
    let date = getState().dailyReportReducer.date;
    date = JSON.parse(JSON.stringify(date));
    var _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/dailyreport/create/" +
      workplaceId +
      "?date=" +
      date;
    dispatch(dailyReportGetRequest());
    return httpGet(_url)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch(dailyReportGetSuccess(json));
      })
      .catch((e) => {
        dispatch(addAlert("Kunne ikke oprette dagrapport"));
        const state = getState();
        if (
          state &&
          state.routing &&
          state.routing.location &&
          state.routing.location.pathname
        ) {
          let route = state.routing.location.pathname.replace(
            "dagrapport",
            "oversigt"
          );
          dispatch(routeActions.push(route));
        }
        console.log(e);
      });
  };
}

export const SET_DAILY_REPORT_DATE = "SET_DAILY_REPORT_DATE";
export function setDate(date, dailyReportIdLink, employeeId) {
  return {
    type: SET_DAILY_REPORT_DATE,
    date: date,
    dailyReportIdLink,
    dailyReportEmployeeId: employeeId,
  };
}

export const SET_IS_SHOWING_TIME_REGISTRATION =
  "SET_IS_SHOWING_TIME_REGISTRATION";
export const setIsShowingTimeRegistration = (bool) => ({
  type: SET_IS_SHOWING_TIME_REGISTRATION,
  bool,
});

export const DAILY_REPORT_TOGGLE_EDIT = "DAILY_REPORT_TOGGLE_EDIT";
export const dailyReportToggleEdit = (bool) => ({
  type: DAILY_REPORT_TOGGLE_EDIT,
  bool,
});

export const DAILY_REPORT_TOGGLE_EDIT_SIGNATURE =
  "DAILY_REPORT_TOGGLE_EDIT_SIGNATURE";
export const dailyReportToggleEditSignature = (bool) => ({
  type: DAILY_REPORT_TOGGLE_EDIT_SIGNATURE,
  bool,
});

export const DAILY_REPORT_DELETE_SUCCESS = "DAILY_REPORT_DELETE_SUCCESS";
export const dailyReportDeleteSuccess = () => ({
  type: DAILY_REPORT_DELETE_SUCCESS,
});

export function attemptDeleteDailyReport(workplaceId) {
  return (dispatch, getState) => {
    let currentDailyReportId = getState().dailyReportReducer
      .currentDailyReportId;
    var _url = process.env.REACT_APP_webApiEndPoint + "api/dailyreport/delete";
    return httpDelete(_url, { id: currentDailyReportId })
      .then(() => {
        dispatch(dailyReportDeleteSuccess());

        let isAllDeleted = true;
        getState().dailyReportReducer.listOfDailyReports.forEach(
          (dailyreport) => {
            if (
              !dailyreport.deleted &&
              dailyreport.no !== currentDailyReportId
            ) {
              isAllDeleted = false;
            }
          }
        );
        if (isAllDeleted) {
          dispatch(attemptCreateDailyReport(workplaceId));
        } else {
          //fetch a dayly report from a NEVER used date, to get empty data.
          dispatch(
            attemptGetDailyReportInit(null, workplaceId, currentDailyReportId)
          );
        }
      })
      .catch((e) => {
        dispatch(addAlert("Kunne ikke slette dagrapport"));
        console.log(e);
      });
  };
}

//////////////////////////////////////////  SEND EMAIL STUFF /////////////////////////////////////////////////

export const GET_EMAIL_SUGGESTIONS_SUCCESS = "GET_EMAIL_SUGGESTIONS_SUCCESS";
export const getEmailSuggestionsSuccess = (suggestions) => ({
  type: GET_EMAIL_SUGGESTIONS_SUCCESS,
  suggestions,
});

function stripSuggestions(suggestions, alreadyChosen) {
  var newSuggestions = [];
  suggestions.forEach(function (suggestion) {
    var allowedSugg = true;
    //check if already chosen from suggestions
    alreadyChosen.forEach(function (chosen) {
      if (chosen.id === suggestion.id || chosen === suggestion.id)
        allowedSugg = false;
    });
    if (allowedSugg) newSuggestions.push(suggestion);
  });
  return newSuggestions;
}

export function getEmailSuggestions(val, alreadyChosen) {
  var fetchUrl =
    process.env.REACT_APP_webApiEndPoint +
    "api/dailyreports/emails?query=" +
    val;
  return (dispatch) => {
    if (!val) {
      dispatch(getEmailSuggestionsSuccess([]));
      return;
    }
    return httpGet(fetchUrl)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        var jsonReponse = stripSuggestions(json, alreadyChosen);
        dispatch(getEmailSuggestionsSuccess(jsonReponse));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

/*These actions are unused and only used for debugging*/
export const SEND_EMAILS_REQUEST = "SEND_EMAILS_REQUEST";
export const sendEmailsRequest = () => ({
  type: SEND_EMAILS_REQUEST,
});

export const SEND_EMAILS_SUCCESS = "SEND_EMAILS_SUCCESS";
export const sendEamilsSuccess = () => ({
  type: SEND_EMAILS_SUCCESS,
});

export const SEND_EMAILS_FAILURE = "SEND_EMAILS_FAILURE";
export const sendEmailsFailure = () => ({
  type: SEND_EMAILS_FAILURE,
});

export const SET_SHOW_EMAIL_CONFIRMATION = "SET_SHOW_EMAIL_CONFIRMATION";
export const setShowEmailConfirmation = (bool) => ({
  type: SET_SHOW_EMAIL_CONFIRMATION,
  bool,
});

export function attemptSendEmails(recipients, dailyReportId) {
  var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/dailyreport/send";
  return (dispatch) => {
    dispatch(sendEmailsRequest());
    return httpPut(fetchUrl, { recipients: recipients, id: dailyReportId })
      .then(() => {
        dispatch(sendEamilsSuccess());
      })
      .catch(() => {
        dispatch(sendEmailsFailure());
        dispatch(addAlert("Kunne ikke sende email(s), prøv igen."));
      });
  };
}

////////////////////////////////////////// SAVING LOGIC /////////////////////////////////////////////////

export const SAVE_DAILY_REPORT_REQUEST = "SAVE_DAILY_REPORT_REQUEST";
export const saveDailyReportRequest = () => ({
  type: SAVE_DAILY_REPORT_REQUEST,
});

export const SAVE_DAILY_REPORT_SUCCESS = "SAVE_DAILY_REPORT_SUCCESS";
export const saveDailyReportSuccess = () => ({
  type: SAVE_DAILY_REPORT_SUCCESS,
});

export const SAVE_DAILY_REPORT_FAILURE = "SAVE_DAILY_REPORT_FAILURE";
export const saveDailyReportFailure = () => ({
  type: SAVE_DAILY_REPORT_FAILURE,
});

export function attemptSaveDayReport() {
  return (dispatch, getState) => {
    dispatch(saveDailyReportRequest());
    let isValid = true;

    if (!isUsageValid(dispatch, getState)) {
      dispatch(addAlert("Fejl i Materiel/Materiale"));
      isValid = false;
    }

    if (!isActivitiesValid(dispatch, getState)) {
      dispatch(addAlert("Fejl i aktiviteterne"));
      isValid = false;
    }

    if (!isEmployeesValid(dispatch, getState)) {
      dispatch(addAlert("Fejl i timeregistrering"));
      isValid = false;
    }

    if (!isDeliveryNotesValid(dispatch, getState)) {
      dispatch(addAlert("Fejl i følgesedlerne"));
      isValid = false;
    }

    if (isValid) dispatch(finalSaveDailyReport());
    else dispatch(saveDailyReportFailure());
  };
}

export function attemptSaveImages(currentDailyReportId, getState, dispatch) {
  var _url =
    process.env.REACT_APP_webApiEndPoint + "api/dailyreport/images/register";
  let images = getState().dailyReportReducer.pics.map((x) => x.id);

  return httpPut(_url, { id: currentDailyReportId, images: images }).catch(
    () => {
      dispatch(addAlert("Kunne ikke gemme billeder."));
      throw new Error("Kunne ikke gemme billeder");
    }
  );
}

export function finalSaveDailyReport() {
  return (dispatch, getState) => {
    let currentDailyReportId = getState().dailyReportReducer
      .currentDailyReportId;

    return attemptSaveUsage(currentDailyReportId, getState, dispatch)
      .then(() => attemptSaveActivities(currentDailyReportId, getState, dispatch))
      .then(() => attemptSaveEmployees(currentDailyReportId, getState, dispatch))
      .then(() => attemptSaveDescription(currentDailyReportId, getState, dispatch))
      .then(() => attemptSaveDeliveryNotes(currentDailyReportId, getState, dispatch))
      .then(() => attemptSaveMeasurements(currentDailyReportId, getState, dispatch))
      .then(() => attemptSaveControlAreas(currentDailyReportId, getState, dispatch))
      .then(() => attemptSaveRemark(currentDailyReportId, getState, dispatch))
      .then(() => attemptSaveImages(currentDailyReportId, getState, dispatch))
      .then(
        function () {
          //on success
          dispatch(saveDailyReportSuccess());
          //if its a edit mode, tell the server it has been success edited
          if (getState().dailyReportReducer.dailyReportIsEdit) {
            setDailyReportHasBeenEditited(currentDailyReportId);
          }
        },
        function (reason) {
          //on failure
          dispatch(saveDailyReportFailure());
          console.error("error when saving dagrapport: ", reason);
        }
      )
  };
}

export function setDailyReportHasBeenEditited(currentDailyReportId) {
  var fetchUrl = process.env.REACT_APP_webApiEndPoint + "api/dailyreport/edit";
  httpPut(fetchUrl, { id: currentDailyReportId }).catch((e) => {
    console.error(e);
  });
}

////////////////////////////////////////// EMPLOYEE STUFF /////////////////////////////////////////////////

export const GET_EMPLOYEE_SUGGESTIONS_SUCCESS =
  "GET_EMPLOYEE_SUGGESTIONS_SUCCESS";
export function getEmployeeSuggestionsSuccess(suggestions) {
  return {
    type: GET_EMPLOYEE_SUGGESTIONS_SUCCESS,
    suggestions: suggestions,
  };
}

export function getEmployeeSuggestions(val) {
  var fetchUrl =
    process.env.REACT_APP_webApiEndPoint + "/api/employee/search?query=" + val;
  return (dispatch, getState) => {
    if (!val) {
      dispatch(getEmployeeSuggestionsSuccess([]));
      return;
    }
    return httpGet(fetchUrl)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        let alreadyChosen = getState().dailyReportEmployeesReducer.employees.concat(
          getState().dailyReportEmployeesReducer.registeredEmployees
        );
        var jsonReponse = stripSuggestions(json, alreadyChosen);
        dispatch(getEmployeeSuggestionsSuccess(jsonReponse));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export const WORKPLACE_ADD_EMPLOYEE_REQUEST = "WORKPLACE_ADD_EMPLOYEE_REQUEST";
export function workplaceAddEmployeeRequest(employee) {
  return {
    type: WORKPLACE_ADD_EMPLOYEE_REQUEST,
    employee: {
      ...employee,
      absence: null,
      shack: false,
      mileage: 0,
      timeRegistrations: [
        {
          employeeFunction: null,
          hours: 0,
          nightHours: 0,
        },
      ],
    },
  };
}

export const WORKPLACE_ADD_EMPLOYEE_SUCCESS = "WORKPLACE_ADD_EMPLOYEE_SUCCESS";
export function workplaceAddEmployeeSuccess() {
  return {
    type: WORKPLACE_ADD_EMPLOYEE_SUCCESS,
  };
}

export function attemptAddEmployee(employee, workplaceId) {
  return (dispatch) => {
    var _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/workplace/" +
      workplaceId +
      "/addemployee";
    dispatch(workplaceAddEmployeeRequest(employee));
    dispatch(getEmployeeSuggestionsSuccess([]));
    return httpPut(_url, { id: employee.id })
      .then(() => {
        dispatch(workplaceAddEmployeeSuccess());
      })
      .catch(() => {
        dispatch(rmEmployeeFromWorkplaceSuccess(0));
        dispatch(addAlert("Kunne ikke tilføje mearbejderen"));
      });
  };
}

export const REMOVE_EMPLOYEE_FROM_WORKPLACE_2 = "REMOVE_EMPLOYEE_FROM_WORKPLACE_2";
export function rmEmployeeFromWorkplaceSuccess(employeeIndex) {
  return {
    type: REMOVE_EMPLOYEE_FROM_WORKPLACE_2,
    employeeIndex: employeeIndex,
  };
}

export function rmEmployeeFromWorkplace(employeeIndex, workplaceId) {
  return (dispatch, getState) => {
    var employee = getState().dailyReportEmployeesReducer.employees[
      employeeIndex
    ];
    let totalHours = 0;
    employee.timeRegistrations.forEach((t) => {
      totalHours += t.hours + t.nightHours;
    });
    //find the sum of night and normal hours on employee
    if (employee.absence || totalHours !== 0) {
      dispatch(addAlert("Kan ikke fjerne medarbejder der er registreret for"));
      return;
    }
    var _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/workplace/" +
      workplaceId +
      "/rmemployee";

    return httpDelete(_url, { employeeId: employee.id })
      .then(() => dispatch(rmEmployeeFromWorkplaceSuccess(employeeIndex)))
      .catch(() => {
        dispatch(
          addAlert("Der skete en fejl, medarbejderen kunne ikke fjernes.")
        );
      });
  };
}

export const DAILY_REPORT_SET_EMPLOYEE_IS_DRAGGING =
  "DAILY_REPORT_SET_EMPLOYEE_IS_DRAGGING";
export function setEmployeeIsDragging(bool) {
  return {
    type: DAILY_REPORT_SET_EMPLOYEE_IS_DRAGGING,
    employeeIsDragging: bool,
  };
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/actions.js